import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import './SurveyThankYou.css';

const SurveyThankYou = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const surveyId = location.state?.surveyId;

  useEffect(() => {
    if (!surveyId) {
      toast.error(t('surveyThankYou.invalidSubmission') || 'Invalid survey submission');
      navigate('/survey');
    }
  }, [surveyId, navigate, t]);

  return (
    <div className="survey-thank-you-page">
      <div className="thank-you-container">
        <div className="success-icon">
          <svg width="100" height="100" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" fill="#27ae60" />
            <path 
              d="M30 50 L45 65 L70 35" 
              stroke="white" 
              strokeWidth="6" 
              fill="none" 
              strokeLinecap="round" 
              strokeLinejoin="round" 
            />
          </svg>
        </div>
        
        <h1>{t('surveyThankYou.thankYou') || 'Thank You for Participating!'}</h1>
        <p className="subtitle">
          {t('surveyThankYou.recordedSuccessfully') || 'Your survey response has been recorded successfully'}
        </p>
        
        {surveyId && (
          <div className="survey-id-box">
            <p className="id-label">{t('surveyThankYou.surveyId') || 'Survey ID'}:</p>
            <code className="survey-id">{surveyId}</code>
          </div>
        )}
        
        <p className="survey-info">
          {t('surveyThankYou.appreciationMessage') || 
            'Your response helps us understand voter sentiments across Bihar. Thank you for participating in our election survey!'}
        </p>
        
        <div className="action-buttons">
          <button 
            onClick={() => navigate('/')} 
            className="btn-primary"
            title={t('common.backToHome') || 'Back to Home'}
          >
            {t('surveyThankYou.backToHome') || 'Back to Home'}
          </button>
          <button 
            onClick={() => navigate('/survey/results')} 
            className="btn-secondary"
            title={t('surveyResults.title') || 'View Survey Results'}
          >
            {t('surveyThankYou.viewResults') || 'View Survey Results'}
          </button>
        </div>
        <div className="footer-content">
          <p className="tech-credit">
            {t('common.techProvidedBy') || 'Our tech Partner:'}
            {' '}
            <span className="provider-name">
              <a href="https://b2world.in" target="_blank" rel="noopener noreferrer">
                <strong>B2World</strong>
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SurveyThankYou;
